import { Component, OnInit, Input } from '@angular/core';

import { AmbienteService } from 'src/app/core/multi-tenancy/ambiente.service';
import { UsuarioService } from 'src/app/seguranca/usuario/usuario/usuario.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-cabecalho-de-impressao',
  templateUrl: './cabecalho-de-impressao.component.html',
  styleUrls: ['./cabecalho-de-impressao.component.css']
})
export class CabecalhoDeImpressaoComponent implements OnInit {

  @Input() nomeRelatorio = '';
  @Input() carregarOnLoad = true;
  @Input() acao: 'relatorio' | 'formulario' | '' = '';

  @Input() exibirUsuario = true;

  nomeEmpresaCliente = '';
  dataAtual = new Date();
  versaoAPI = '';
  versaoUI = environment.nomeVersao;
  usuarioExecutor = '';
  arquivoLogoGrandeHorizontal = '';

  constructor(
    private ambienteService: AmbienteService
  ) { }

  ngOnInit(): void {
    this.carregarOnLoad = true;
    if ( this.carregarOnLoad ) {
      setTimeout(() => {
        this.carregarDados();
      }, 100);
    }
  }

  public carregarDados(): void {
    this.dataAtual = new Date();
    const ambiente          = this.ambienteService.getAmbiente();
    this.versaoAPI          = ambiente.getVersaoAPI();
    this.nomeEmpresaCliente = ambiente.getNome();
    this.arquivoLogoGrandeHorizontal = ambiente.getArquivoLogoGrandeHorizontal()
    this.usuarioExecutor    = UsuarioService.getUsuarioFromLocalStorage().nome;
  }

}
